const GlobalStockChart = require('./GlobalStockChart');

module.exports = GlobalStockChart;
